// extracted by mini-css-extract-plugin
export var areas = "areas-module--areas--KNB7a";
export var areasContainer = "areas-module--areasContainer--QaDVo";
export var secondAreas = "areas-module--secondAreas--QdIZQ";